
import Vue from 'vue'
import { Prop, Watch, Component } from 'vue-property-decorator'
import { Agency } from '../../global/models'
import { VForm } from '../../global/vuetify.types'
import ProfileImage from './ProfileImage.vue'

@Component({
  components: { ProfileImage }
})
export default class ProfileForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  private readonly value!: Agency

  @Prop({ type: String, default: 'create' })
  private readonly mode!: string

  @Prop({ type: String, default: null })
  private readonly error!: string

  @Prop({ type: Array, default: () => [] })
  private readonly nameError!: string[]

  @Prop({ type: Array, default: () => [] })
  private readonly slugError!: string[]

  agency: Partial<Agency> = { accounting: {} }

  get yesOrNo() {
    return [
      { text: 'Yes', value: true },
      { text: 'No', value: false }
    ]
  }

  get statusOptions() {
    return [
      { text: 'Active', value: 'active' },
      { text: 'Disabled', value: 'disabled' }
    ]
  }

  get emailRules() {
    return [
      (v: string) => !!v || 'Email is required',
      (v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || 'Invalid email format'
    ]
  }

  get requiredRule() {
    return (v: string) => !!v || 'Field is required'
  }
  
  get requiredBoolRules() {
    return (v: boolean) => v === true || v === false || 'Field is required'
  }

  get logoPath() {
    return this.agency.logoPath && this.agency.logoPath !== '' ? this.mediaUrl + this.agency.logoPath : ''
  }

  get mediaUrl() {
    return this.$store.state.auth.mediaUrl
  }

  get user() {
    return this.$store.state.auth
  }

  get form() {
    return this.$refs.form as VForm
  }

  @Watch('value', { immediate: true })
  private valueChanged(val: Agency) {
    this.agency = val

    if (!this.agency.accounting) {
      this.agency.accounting = {}
    }
  }

  @Watch('agency')
  private agencyChanged(val: Agency) {
    this.$emit('input', val)
  }

  validate() {
    return this.form.validate()
  }

  slugNumCheck(v: string) {
    if (Number.isNaN(+v)) {
      return true
    } else if (v !== this.agency.id) {
      return 'Only your own agency ID can be used as your slug.'
    }
    return true
  }

  slugLengthCheck(v: string) {
    if (!v) {
      return 'Value is required'
    }

    if (v.length > 32) {
      return 'Slug to long, please use a slug of 32 characters or less.'
    }
    return true
  }

  bsbRule(value: string) {
    return this.validBSB(value) || 'Invalid BSB'
  }

  accountNumberRule(value: string) {
    return this.validAccountNumber(value) || 'Invalid account number'
  }

  validBSB(value: string) {
    if (!value) {
      return true
    }
    const bsb = value.replace(/(\s|-)+/, '').trim()
    return /^\d{6}$/.test(bsb)
  }

  validAccountNumber(value: string) {
    if (!value) {
      return true
    }
    const account = value.replace(/(\s|-)+/, '').trim()
    return /^\d{6,9}$/.test(account)
  }

  updateLogo(path: string) {
    this.agency.logoPath = path
  }

  updateBanner(path: string) {
    this.agency.bannerPath = path
  }
}
